/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IngestionLogsErrorDto
 */
export interface IngestionLogsErrorDto {
    /**
     * 
     * @type {string}
     * @memberof IngestionLogsErrorDto
     */
    sourcePath: string;
    /**
     * 
     * @type {string}
     * @memberof IngestionLogsErrorDto
     */
    message: string;
}

/**
 * Check if a given object implements the IngestionLogsErrorDto interface.
 */
export function instanceOfIngestionLogsErrorDto(value: object): value is IngestionLogsErrorDto {
    if (!('sourcePath' in value) || value['sourcePath'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function IngestionLogsErrorDtoFromJSON(json: any): IngestionLogsErrorDto {
    return IngestionLogsErrorDtoFromJSONTyped(json, false);
}

export function IngestionLogsErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IngestionLogsErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sourcePath': json['sourcePath'],
        'message': json['message'],
    };
}

export function IngestionLogsErrorDtoToJSON(json: any): IngestionLogsErrorDto {
    return IngestionLogsErrorDtoToJSONTyped(json, false);
}

export function IngestionLogsErrorDtoToJSONTyped(value?: IngestionLogsErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourcePath': value['sourcePath'],
        'message': value['message'],
    };
}

